import { useState } from "react";
import { useSelector } from "react-redux";
import { GetCurrency } from "../../helpers/getCurrency";
import { PackageDto } from "../../redux/homepage/type";
import { languageSelector } from "../../redux/languages";
import { getLocalization } from "../../redux/localization";
import PaymentModal from "../paymentmodal";
import { PackageField } from "./packageData";

const PackageCard = ({
  isMonth,
  data,
}: {
  isMonth: "mo" | "ye";
  data: PackageDto;
}) => {
  const [show, setShow] = useState(false);
  const language = useSelector(languageSelector);
  const t = useSelector(getLocalization);

  return (
    <div className="packageCardComponent">
      <h2>{data.Name}</h2>
      <p className="discounted">
        {isMonth === "mo"
          ? GetCurrency(data.ListPriceMonthly, data.CurrencyCode, language.Code)
          : GetCurrency(data.ListPriceYearly, data.CurrencyCode, language.Code)}
      </p>
      <p className="campaignPrice">
        {isMonth === "mo"
          ? GetCurrency(
              data.CampaignPriceMonthly,
              data.CurrencyCode,
              language.Code
            )
          : GetCurrency(
              data.CampaignPriceYearly,
              data.CurrencyCode,
              language.Code
            )}
      </p>
      <div style={{ color: "#b2dab2" }}>
        {t.formatString(
          t.getString("save"),
          GetCurrency(
            isMonth === "mo"
              ? data.ListPriceMonthly - data.CampaignPriceMonthly
              : data.ListPriceYearly - data.CampaignPriceYearly,
            data.CurrencyCode,
            language.Code
          )
        )}
      </div>
      <ol>
        {PackageField(data, t)
          .filter((a) => a.value)
          .map((x) => (
            <li className={x.isText ? "check" : x.value ? "check" : "uncheck"}>
              {x.field}
              {x.isText ? " : " + x.value : ""}
            </li>
          ))}
        {PackageField(data, t)
          .filter((a) => !a.value)
          .map((x) => (
            <li className={x.isText ? "check" : x.value ? "check" : "uncheck"}>
              {x.field}
              {x.isText ? " : " + x.value : ""}
            </li>
          ))}
      </ol>
      <PaymentModal
        packageData={data}
        show={show}
        setShow={setShow}
        IsMonth={isMonth === "mo"}
      />
      <button className="primaryButton" onClick={() => setShow(true)}>
        {t.getString("Buy")}
      </button>
    </div>
  );
};
export default PackageCard;
